import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var AdyenIssueIA = function AdyenIssueIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bidl+1",
    defaultMessage: [{
      "type": 0,
      "value": "Para resolver problemas relacionados com a Adyen, é mais eficiente contactar diretamente a respetiva equipa de apoio. Estes são alguns dos principais aspetos que deve verificar antes de contactar o apoio:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "V5yO9f",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Conclua a configuração da conta"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": certifique-se de que a sua configuração com a Adyen foi concluída em 6 semanas. Caso contrário, a sua conta pode ser temporariamente suspensa."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rrru2r",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verifique a sua conta:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " certifique-se de que a Adyen verificou a sua conta. Não é possível começar a emitir os seus pagamentos enquanto a sua conta bancária não estiver verificada pela Adyen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YOwZcP",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Forneça as informações necessárias"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": a Adyen pode solicitar informações adicionais para verificação, especialmente se o volume de vendas da sua marca atingir um valor específico (1000 £/1000 €/1000 CHF). Certifique-se de que faculta todas as informações solicitadas."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "6dPuyj",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verifique o tipo de conta"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": confirme se o tipo de conta (comercial ou individual) que selecionou corresponde ao tipo apresentado no seu extrato bancário. Esta informação é crucial para a verificação da conta."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};